import toastr from "toastr"

// toastr is the app's toast library (styled in components/_toasts.scss, already
// imported by Reminders/Preferences/Quotes). It ships no type declarations, so
// wrap it once here — that gives the dashboard a typed surface and one place to
// tune options if the FSP admin toasts ever need to differ.
type ToastrOptions = { escapeHtml: boolean }

type ToastrClient = {
  success: (message: string, title?: string, options?: ToastrOptions) => void
  error: (message: string, title?: string, options?: ToastrOptions) => void
}

const client = toastr as unknown as ToastrClient

// toastr renders the message as HTML (escapeHtml defaults to false). These
// toasts interpolate names people choose for themselves and error strings from
// the server, so escaping is not optional.
const OPTIONS: ToastrOptions = { escapeHtml: true }

export const toastSuccess = (message: string) => client.success(message, undefined, OPTIONS)

// Appends the server's reason when there is one — an "Action failed" toast with
// no detail leaves the admin guessing whether to retry.
export const toastError = (message: string, error?: unknown) => {
  const reason = (error as { message?: string } | null | undefined)?.message
  client.error(reason ? `${message}: ${reason}` : message, undefined, OPTIONS)
}
